import BoroughTab from "./BoroughTab";

export default BoroughTab;
